import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {updateFileDescription} from '../../actions/user-api';
import * as R from 'ramda';
import $ from 'jquery';
import { useEffect } from 'react';

export const ModalFileDescription = ({userId, currentPath, onDocumentEdited, document }) => {
	const dispatch = useDispatch();
	const formRef = useRef();
	const [fileDescription, setFileDescription] = useState(R.isNil(document) ? undefined : document.description);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if(!R.isNil(document))
			setFileDescription(document.description);
	}, [document])
	return (
		<div className="modal fade px-0" id="ModalFileDescription" aria-labelledby="gestionLabel" aria-hidden="true">
			<div className="modal-dialog container-copy px-2">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-aux rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Gestion docs</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-aux text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="gestionLabel">Modifier description du fichier</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default pt-0">
						{/* <p className="h4 o-66 text-aux">Gérer les Dossiers</p> */}
						<form className="block" noValidate ref={formRef}>
							<div className="form-group">
								<label className="h6 font-weight-bolder" htmlFor="nl">Description du fichier :</label>
								<input id="nl" className="form-control" placeholder="description" value={fileDescription} onChange={(e) => setFileDescription(e.target.value)} required />
							</div>
						</form>
						<div className="flex-row justify-content-between pt-0 mt-3">
							{/* <button type="button" className="btn btn-light" data-dismiss="modal">Annuler</button> */}
							<div className="flex-row justify-content-end ml-auto">
								<button type="button" className="btn btn-light ms-auto" data-dismiss="modal">Annuler</button>
								<button type="button" className={"btn btn-aux loading-btn ml-2" + (isLoading ? " show" : "")} onClick={(e) => {
									e.preventDefault();
									formRef.current.classList.add('was-validated');
									if (formRef.current.checkValidity()){
										setIsLoading(true);
										dispatch(updateFileDescription(userId, document, fileDescription, currentPath))
										.then((editedFile) => {
											onDocumentEdited(editedFile);
											setIsLoading(false);
											$('#ModalFileDescription').modal("hide");
											setFileDescription("");
											formRef.current.classList.remove('was-validated')
										});
									}
								}}><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Modifier</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}